import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const TOGGLE_FILTERING_RULE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation toggleFilteringRule($input: UpdateFilteringRuleInput!) {
    updateFilteringRule(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
